<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4">
<h2 class="sec_front">INTRODUCTION</h2>
<p class="noindent">On March 31, 1992, when the American battleship USS <em class="italic">Missouri</em> was decommissioned for the second and final time, the age of the battleships irrevocably came to an end. At that time <em class="italic">Missouri</em> was the last of its kind, representing a breed of warship that had dominated the world’s oceans in the early 20th century until its demise in World War II and its short-lived comeback in the final stages of the Cold War. Today, all the battleships are gone except a few, having survived as floating museums, thus having stood the test of time. Battleships were used as signs of national power and prestige, in a manner similar to the atomic weapons of today, and were thus considered a major factor in both diplomacy and military strategy for decades. This is their story.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Introduction.vue?17feaffa